export enum CrmLeadStatus {
	New = 0,
	Contacted = 10,
	Qualified = 20,
	Proposal = 30,
	Won = 40,
	Lost = 50,
	OnHold = 60,
}
